import { IMassAdjustmentFormModel } from '../form/mass-adjustment-form.model';
import { LevelOfAdjustment } from '@carm/_core/declarations/models/common';
import { IMassAdjustmentRequest, AdjustmentField, AdjustmentReason, AdjustmentDeclaration } from '../mass-adjustment-api.model';
import { ICadGoodResponse, ICadInvoiceResponse } from '../api';

export const mapSubmitMassAdjustmentFormModelToRequest = (formData: IMassAdjustmentFormModel, caseNumber: string,
                                                          language: string, importerBN: string, thirdPartyBN15?: string): IMassAdjustmentRequest => {
    const adjustedFields: AdjustmentField[] = formData.adjustFields.map( af => ({ fieldName: af.fieldName, fieldValue: af.newValue, cbsaCaseNo: caseNumber }));
    const reasons: AdjustmentReason[] = formData.reason.map(reason => ({appealsProgramCode: (reason.appealsProgramCode).split(' - ')[0],
     reasonCode: reason.reasonCode, legislativeAuthority: reason.legislativeAuthority, justification: reason.justification, cbsaCaseNo: caseNumber}));
    let declarations: AdjustmentDeclaration[];

    switch (formData.level.adjustmentLevel) {
        case LevelOfAdjustment.DETAILS_WAREHOUSE: {
            declarations = formData.selectedTransactionIds.map(transactionNumber =>
                 ({transactionNumber, cbsaCaseNo: caseNumber, adjustedLines: [{
                    transactionNumber: transactionNumber,
                    lineNumber: null,
                    cbsaCaseNo: caseNumber
                 }]}));
            break;
        }
        case LevelOfAdjustment.GOODS: {
            declarations = mapAdjustedGoodLinesWithDeclarationMap(formData, caseNumber);
            break;
        }
        case LevelOfAdjustment.INVOICE: {
            declarations = mapAdjustedInvoiceLinesWithDeclarationMap(formData, caseNumber);
        }
    }
    const request =  {
        cbsaCaseNo: caseNumber,
        complianceCaseNo: formData.complianceCaseNo,
        adjustedFields,
        reasons,
        declarations,
        language,
        importerBN,
        brokerBN: thirdPartyBN15,
        adjustmentLevel: formData.level.adjustmentLevel
    };
    return request;
};


export function mapAdjustedInvoiceLinesWithDeclarationMap(
    formData: IMassAdjustmentFormModel,caseNumber: string
  ): AdjustmentDeclaration[] {
    if (!formData?.level?.selectedInvoices || formData.level.selectedInvoices.length === 0) {
      return [];
    }
    
    // Group goods by transaction number
    const groupedByTransaction = formData.level.selectedInvoices.reduce(
      (acc, invoice) => {
        if (!acc[invoice.transactionNumber]) {
          acc[invoice.transactionNumber] = [];
        }
        acc[invoice.transactionNumber].push(invoice);
        return acc;
      },
      {} as Record<string, ICadInvoiceResponse[]>
    );
  
    // Build AdjustmentDeclaration array
    const adjustmentDeclarations: AdjustmentDeclaration[] = Object.entries(groupedByTransaction).map(
      ([transactionNumber, invoices]) => ({
        transactionNumber,
        cbsaCaseNo: caseNumber,
        adjustedLines: invoices.map((g) => ({
          transactionNumber: g.transactionNumber,
          lineNumber: g.invoiceLineNo.toString(),
          cbsaCaseNo: caseNumber
        }))
      })
    );  
    return adjustmentDeclarations;
  }


  export function mapAdjustedGoodLinesWithDeclarationMap(
    formData: IMassAdjustmentFormModel,caseNumber: string
  ): AdjustmentDeclaration[] {
    if (!formData?.level?.selectedGoods || formData.level.selectedGoods.length === 0) {
      return [];
    }
    
    // Group invoices by transaction number
    const groupedByTransaction = formData.level.selectedGoods.reduce(
      (acc, good) => {
        if (!acc[good.transactionNumber]) {
          acc[good.transactionNumber] = [];
        }
        acc[good.transactionNumber].push(good);
        return acc;
      },
      {} as Record<string, ICadGoodResponse[]>
    );
  
    // Build AdjustmentDeclaration array
    const adjustmentDeclarations: AdjustmentDeclaration[] = Object.entries(groupedByTransaction).map(
      ([transactionNumber, goods]) => ({
        transactionNumber,
        cbsaCaseNo: caseNumber,
        adjustedLines: goods.map((g) => ({
          transactionNumber: g.transactionNumber,
          lineNumber: g.goodLineNo.toString(),
          cbsaCaseNo: caseNumber
        }))
      })
    );  
    return adjustmentDeclarations;
  }
